import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

interface ConfirmationDialogProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonVariant?: string;
    isConfirming?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    show,
    onClose,
    onConfirm,
    title,
    message,
    confirmButtonText = 'Confirm',
    cancelButtonText = 'Cancel',
    confirmButtonVariant = 'primary',
    isConfirming = false,
}) => {
    return (
        <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={!isConfirming}>
            <Modal.Header closeButton={!isConfirming}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Pesan bisa berupa string atau elemen JSX yang lebih kompleks */}
                {typeof message === 'string' ? <p>{message}</p> : message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isConfirming}>
                    {cancelButtonText}
                </Button>
                <Button variant={confirmButtonVariant} onClick={onConfirm} disabled={isConfirming}>
                    {isConfirming ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Processing...
                        </>
                    ) : (
                        confirmButtonText
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationDialog;